<script>
/**
 * @Author: zhangxiaojian
 * @Date: 2025/6/25
 * @LastEditors: zhangxiaojian
 * @Description: 知识问答组件
 **/
import Knowledge from './components/Knowledge.vue'
import History from './components/History.vue'
export default {
  name: 'KnowledgeQARenderer',
  data() {
    return {
      historyCount: -1, // 历史记录条数
      historyList: [], // 历史记录列表
      isMessage: true // 是否显示对话界面
    }
  },
  props: {
    // 知识类型 0--知识问答，1--运维助手
    knowledgeType: {
      type: Number,
      default: 0
    }
  },
  emits: [
    /**
     * 关闭知识问答浮层
     */
    'closed'
  ],
  components: {
    Knowledge,
    History
  },
  methods: {
    /**
     * 关闭知识问答浮层
     */
    closeDialog() {
      this.$emit('closed')
    },
    /**
     * 对话和历史记录切换
     * @param isMessage 状态
     */
    messageViewControl(isMessage) {
      this.isMessage = isMessage
    },
    /**
     * 更新历史记录数量
     * @param {Number} count 历史记录条数
     */
    refreshHistoryCount(count) {
      this.historyCount = count
    },
    /**
     * 加载历史记录
     * @param list
     */
    loadHistory(list) {
      this.messageViewControl(true)
      this.historyList = list
    },
    /**
     * 更新对话列表，此处将覆盖历史记录列表，用于历史记录和对话记录切换时数据保持一致
     * @param list
     */
    messageUpdate(list) {
      this.historyList = list
    }
  }
}
</script>

<template>
  <div class="knowledge-renderer">
    <div class="knowledge-renderer-header">
      <div class="knowledge-renderer-header-title">
        {{ isMessage ? '知识问答' : '对话记录' }}
        <span
          class="knowledge-renderer-header-title-history"
          v-if="!isMessage && historyCount > -1"
          >共 {{ historyCount }} 条</span
        >
      </div>
      <div class="knowledge-renderer-header-operate">
        <span>
          <img
            v-if="this.knowledgeType === 0"
            v-show="isMessage"
            src="../../assets/img/knowledge/history.png"
            alt="历史"
            @click="() => messageViewControl(false)"
          />
          <img
            v-show="!isMessage"
            alt="返回"
            src="../../assets/img/knowledge/back.png"
            @click="() => messageViewControl(true)"
          />
        </span>
        <span @click="closeDialog">
          <img src="../../assets/img/knowledge/close.png" alt="关闭" />
        </span>
      </div>
    </div>
    <div class="knowledge-renderer-tip" v-if="isMessage">
      以下内容由AI生成，请甄别使用
    </div>
    <Knowledge
      :knowledge-type="knowledgeType"
      v-if="isMessage"
      :list="historyList"
      @messageUpdate="messageUpdate"
    />
    <History
      v-else
      @loadHistory="loadHistory"
      @refreshHistoryCount="refreshHistoryCount"
    />
  </div>
</template>

<style scoped lang="scss">
.knowledge-renderer {
  background-image: url('../../assets/img/knowledge/bg.png');
  background-size: cover;
  position: fixed;
  right: 0;
  height: 100%;
  width: 640px;
  bottom: 0;
  z-index: 999;
  padding: 17px 0;
  display: flex;
  flex-direction: column;
  box-shadow: 1px 0px 10px 0px #0057b8;
  @media (min-width: 1600px) {
    width: 800px; // 大屏设备
  }
  &-tip {
    font-size: 12px;
    color: #7d8fb4;
    margin-top: 10px;
    padding: 0 17px;
  }
  &-header {
    display: flex;
    justify-content: space-between;
    padding: 0 17px;
    &-title {
      font-size: 16px;
      color: #333;
      font-weight: bold;
      &-history {
        color: #969798;
        font-size: 14px;
        font-weight: normal;
        margin-left: 8px;
      }
    }
    &-operate {
      display: flex;
      img {
        width: 17px;
        cursor: pointer;
        margin: 0 5px;
      }
    }
  }
}
</style>
